import { render, staticRenderFns } from "./AddEditTemplateModal.vue?vue&type=template&id=71cc67ca&scoped=true&"
import script from "./AddEditTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./AddEditTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc67ca",
  null
  
)

export default component.exports